import { render, staticRenderFns } from "./JobGroupModal.vue?vue&type=template&id=50787c77"
import script from "./JobGroupModal.vue?vue&type=script&lang=js"
export * from "./JobGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports